module.exports = __webpack_public_path__ + "img/hppi.cd8a1044.png";